export default __webpack_public_path__ + "static/media/central_andes_2_3.dfb2e14b.JPG";